import { render, staticRenderFns } from "./LocationTransactions.vue?vue&type=template&id=2345523f&"
import script from "./LocationTransactions.vue?vue&type=script&lang=js&"
export * from "./LocationTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports